import { render, staticRenderFns } from "./TreatmentProjectList.vue?vue&type=template&id=706362ec&scoped=true"
import script from "./TreatmentProjectList.vue?vue&type=script&lang=js"
export * from "./TreatmentProjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706362ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706362ec')) {
      api.createRecord('706362ec', component.options)
    } else {
      api.reload('706362ec', component.options)
    }
    module.hot.accept("./TreatmentProjectList.vue?vue&type=template&id=706362ec&scoped=true", function () {
      api.rerender('706362ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/treatment/project/TreatmentProjectList.vue"
export default component.exports